import React, { Component } from 'react';
import history from '../../../routes/history';
import connectCommon from '../../common/common-hoc';
import { connect } from 'react-redux';
import * as actionCreatorData from '../../../redux/actions/data-action';
import * as actionCreatorLookup from '../../../redux/actions/lookup-action';
import { Box } from '../../../third-party-components/material-ui';
import { DemoContainer, DemoQuestionText } from '../common/controls';
import { AssessmentContentHeader } from '../../assessment/common';
import { TaskType, TaskSegment } from '../../../redux/actions/data-action';
import { aiVersions } from '../../../Constants'
import { translateLabel } from '../../assessment/common/task-utility';

const questions = [
  'Describe how these behaviors cause serious problems for you at home, in school, at work, or with your friends.',
  'Do you have any other problems?',
  'What are your main strengths or skills?'
];

class DemographicAdditionalQuestions extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleNext = this.handleNext.bind(this);
  }

  componentDidMount() {
    window.history.pushState(null, null, history.location.href);
    window.onpopstate = function(event) {
        history.go(1);
    };

    var version = parseInt(sessionStorage.getItem('temp-version-id'));
        
    const { tasks } = this.props;
    const taskIndex = tasks.map(task => task.id).indexOf(TaskType.RATING.id);
    const omittedItems = [];

    tasks[taskIndex].tasks.filter(task => !task.skipped).forEach((task, index) => {
      if (task.response < -1) {
        omittedItems.push((index + 1));
      }
    });

    var version = parseInt(sessionStorage.getItem('temp-version-id'));

    if (aiVersions.includes(version)) {
        if(!omittedItems.length > 0) {
            history.push("/Assessment/Complete");
        } else {
          history.push("/Assessment/Omission");
        }
    }
  }

  handleBack() {
    const prevLink = this.getPreviousLink();
    history.push(prevLink);
  }

  handleNext() {
    const nextLink = this.getNextLink();
    history.push(nextLink);
  }

  getPreviousLink() {
    const { tasks, match } = this.props;
    const { index } = match.params;
    const prevIndex = parseInt(index) - 1;

    if (index > 1) {
      return `/Demographic/AdditionalQuestions/${prevIndex}`;
    } else {
      const taskIndex = tasks.map(task => task.id).indexOf(TaskType.RATING.id);
      const currentTasks = tasks[taskIndex].tasks.filter(task => !task.skipped);
      const lastIndex = currentTasks.length;
      return `/Assessment/Tasks/${TaskType.RATING.type}/${TaskSegment.TASK}/${lastIndex}`;
    }
  }

  getNextLink() {
    const { tasks, match } = this.props;
    const { index } = match.params;
    const nextIndex = parseInt(index) + 1;
    const taskIndex = tasks.map(task => task.id).indexOf(TaskType.RATING.id);
    const omittedItems = [];

    tasks[taskIndex].tasks.filter(task => !task.skipped).forEach((task, index) => {
      if (task.response < -1) {
        omittedItems.push((index + 1));
      }
    });

    if (index < 3) {
      return `/Demographic/AdditionalQuestions/${nextIndex}`;
    } else if (omittedItems.length > 0) {
      return '/Assessment/Omission';
    } else {
      return '/Assessment/Complete';
    }
  }

  getFieldLabel() {
    const { index } = this.props.match.params;
    const qIndex = parseInt(index) - 1;
    return questions[qIndex];
  }

  getFieldValue() {
    const { demographics, match } = this.props;
    const rIndex = parseInt(match.params.index) - 1;
    const responses = demographics.additionalQuestions;

    if (!!responses) {
      return responses[rIndex].response;
    } else {
      return '';
    }
  }

  getCounterValue() {
    const { index } = this.props.match.params;
    return index + " OF " + questions.length;
  }

  onChange(e) {
    const { setDemographicsResponse, demographics, match } = this.props;
    const { name, value } = e.target;
    const rIndex = parseInt(match.params.index) - 1;

    let responses = [
      { response: '' },
      { response: '' },
      { response: '' }
    ];

    if (!!demographics.additionalQuestions) {
      responses = demographics.additionalQuestions;
    }

    responses[rIndex].response = value;
    setDemographicsResponse(name, responses);
  }

  render() {
    const { versionID } = this.props;
    
    return (
      <DemoContainer title="Additional Questions" onNextClick={this.handleNext} onBackClick={this.handleBack} label={this.getCounterValue()} overrideLogo={false}>
        <Box className="demo-content" display="flex" flexDirection="column">
          <Box>
            <DemoQuestionText
              className="additional-questions"
              name="additionalQuestions"
              label={this.getFieldLabel()}
              value={this.getFieldValue()}
              onChange={this.onChange}
              multiline={true}
              />
          </Box>
        </Box>
        <div className='progress-label'>{translateLabel(this.getCounterValue(), versionID)}</div>
      </DemoContainer>
    );
  } 
}

const mapStateToProps = (state, ownState) => ({
  demographics: state.data.demographics,
  tasks: state.data.tasks
});

export default connect(mapStateToProps, Object.assign({}, actionCreatorData, actionCreatorLookup))(connectCommon(DemographicAdditionalQuestions));
